export default __webpack_public_path__ + "static/mel-1d9709efc3084a422eab4a52cd2393e7.jpg";